/* eslint-disable no-unused-vars */
import { Form, message } from 'antd';
import { useDispatch } from 'dva';
import { useState, useEffect } from 'react';
import ButtonML from '@/components/button_ml/ButtonML';
// import ModalConfirmML from '@/components/modal_ml/modal_confirm_ml/ModalConfirmML';
import InputML from '@/components/input_all_ml/add_input_ml/AddInputML';
import AddSelectML from '@/components/select_ml/add_select_ml/AddSelectML';
import { CONSTANT } from '../../../constant/index';
import Loading from '@/components/Loading';
import styles from './editMember.less?modules';

const AddMember = (props) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { itemInfo } = props;
  // 发起请求
  const onFinish = (values) => {
    setLoading(true);
    dispatch({
      type: 'ruleginMM/editMember',
      payload: {
        modelId: itemInfo.id,
        values: {
          ...values,
        },
      },
      callback: (data) => {
        setLoading(false);
        if (data) {
          message.error(data.message);
        } else {
          message.success('编辑成功');
          props.handleOk(data);
        }
      },
    });
  };

  const handleCancel = () => {
    props.handleCancel();
  };

  // console.log(itemInfo);
  useEffect(() => {
    if (!itemInfo) {
      return;
    }
    let newData = {};
    newData['modelName'] = itemInfo['modelName'];
    newData['modelStatus'] = itemInfo['modelStatus'];
    newData['description'] = itemInfo['description'];
    form.setFieldsValue({
      ...newData,
    });
  }, [form, itemInfo]);

  return (
    <Loading loading={loading}>
      <Form
        form={form}
        name="control-hooks"
        onFinish={onFinish}
        className={styles.serarchFrom}
      >
        <div className={styles.input_contain}>
          {/* 模型名称 */}
          <InputML
            labelVal="模型名称"
            placeVal="请输入模型名称"
            name="modelName"
            required={[
              {
                required: true,
                whitespace: true,
                message: '请输入模型名称',
              },
            ]}
          />
          {/* 模型状态 */}
          <AddSelectML
            required={[
              {
                required: true,
                message: '请选择模型状态',
              },
            ]}
            height="47px"
            labelwidth="130px"
            labelVal="模型状态"
            placeVal="请选择模型状态"
            name="modelStatus"
            option={CONSTANT.statusList}
          />
          {/* 模型描述 */}
          <InputML
            labelVal="模型描述"
            placeVal="请输入模型描述"
            name="description"
            required={[
              {
                required: true,
                whitespace: true,
                message: '请输入模型描述',
              },
            ]}
          />
        </div>
        <footer className={styles.footer}>
          <ButtonML
            size="large"
            value="取消"
            htmlType="submit"
            fontsize="16px"
            onClick={handleCancel}
          />
          <ButtonML
            size="large"
            value="保存"
            htmlType="submit"
            fontsize="16px"
          />
        </footer>
      </Form>
    </Loading>
  );
};

export default AddMember;
